import Header from '@components/head';
import Layout from '@/layout/Layout';
import BottomCta from '@/modules/home-page/components/bottom-cta';
import CanDo from '@/modules/home-page/components/can-do';
import Effect from '@/modules/home-page/components/effects';
import Faqs from '@/modules/home-page/components/faqs';
import HeroBanner from '@/modules/home-page/components/hero-banner';
import ImportCase from '@/modules/home-page/components/import-case';
import MediaPublic from '@/modules/home-page/components/media-public';
import PricingCom from '@/modules/home-page/components/pricing';
import SolveProblems from '@/modules/home-page/components/solve-problems';
import UsefulExample from '@/modules/home-page/components/useful-example';
import { graphql } from 'gatsby';
import React from 'react';
import * as styles from './index.module.less';
import CommonBlok from '@/components/common-blok';
import StructuredData from '@/components/structured-data';
import Security from '@/modules/home-page/components/security';
import AINote from '@/modules/home-page/components/ai-note';
import HowNottaWork from '@/modules/home-page/components/how-notta-work';
import StatisticsWrapper from '@/modules/home-page/components/statistics-wrapper';
import CompanyLogoList from '@/modules/home-page/components/company-logo';
import MismatchLngDialog from '@/modules/home-page/components/mismatch-lang-dialog';
// import HomePageHeadScript from '@/components/home-page-head-script';

export const HonorPartWrapper = ({ children }) => {
  return (
    <CommonBlok className={styles.honor_part} paddingBottom="0" paddingTop="0">
      {children}
    </CommonBlok>
  );
};

const HomePage = () => {
  return (
    <Layout isNewLayout isHomePage>
      <Header
        cover="https://a.storyblok.com/f/159374/1801x946/1e59455742/open-graph-image-2.png"
        canonical="https://www.notta.ai/"
        htmlAttr={{ lang: 'ja' }}
        title="自動文字起こしサービス | Notta"
        description="Nottaは最新のAI音声認識エンジンを搭載する高精度な文字起こしサービスです。リアルタイム文字起こしと翻訳機能を備え、また、1度に最長5時間までの音声ファイルを素早くテキスト化が可能。PCで音声変換や編集も気軽に行います。"
      />
      {/* <HomePageHeadScript /> */}
      <StructuredData>
        {{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          operatingSystem: 'Windows, Mac, Chrome, Microsoft Edge, Safari, Android, iOS',
          name: 'Notta - 自動的に音声を文字起こし',
          description:
            'Nottaは高精度の音声認識とAI要約機能を使って、1時間の音声をわずか5分で文字起こし・要約します。商談やWeb会議の議事録作成を簡易化し、情報共有を効率的に行います。',
          applicationCategory: 'WebApplication',
          brand: {
            '@type': 'Brand',
            name: 'Notta',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.8',
            bestRating: '5',
            ratingCount: '4526',
          },
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'JPY',
          },
        }}
      </StructuredData>
      <MismatchLngDialog />
      {/* Hero Banner */}
      <HeroBanner />
      <CompanyLogoList className={styles.company_logo_list} />
      {/* 引入Notta的效果 */}
      <Effect />
      <HowNottaWork />
      {/* AI Note */}
      <AINote />
      <StatisticsWrapper />
      {/* 安全 */}
      <CommonBlok isNewLayout>
        <Security />
      </CommonBlok>
      {/* Notta解决的问题 */}
      <SolveProblems />
      {/* Notta can do */}
      <CanDo />
      {/* ほかの便利な機能例 */}
      <UsefulExample />
      {/* Pricing */}
      <PricingCom />
      {/* 导入事例 */}
      <ImportCase />
      {/* FAQs */}
      <Faqs />
      {/* メディア掲載実績 */}
      <MediaPublic />
      {/* bottom cta */}
      <BottomCta />
    </Layout>
  );
};

export default HomePage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
